<template>
  <div>
    <div
      v-show="schoolingChoice || schoolingChoices"
      class="p-md"
    >
      <article class="media">
        <div
          v-if="candidate.profile_photo"
          class="media-left"
        >
          <figure class="image is-48x48">
            <img
              v-if="candidate.profile_photo"
              width="200"
              height="300"
              alt=""
              :src="'/profiles/'+candidate.profile_photo"
            >
            <img
              v-else
              width="150"
              height="300"
              alt=""
              :src="'/img/icons/image.png'"
            >
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p class="title is-4 has-text-weight-light">
              {{ $t('offers.cart.registrations') }} {{
                candidate.first_name
              }}
            </p>
            <div>
              <header class="card-header has-background-primary">
                <span class="card-header-title title is-5 has-text-weight-light has-text-light">{{
                  $t('offers.cart.schooling')
                }}</span>
              </header>
              <div class="box p-sm">
                <div
                  v-if="schooling"
                  class="columns is-size-5"
                >
                  <div class="column  has-text-weight-light">
                    <span v-if="schooling.internship_choice === 'internship'">{{ $t('candidate.choices.boardingschool.internship') }} - </span>
                    <span v-if="schooling.internship_choice === 'internship_7'">{{ $t('candidate.choices.boardingschool.internship_7') }} - </span>
                    <span v-if="schooling.internship_choice === 'internship_full'">{{ $t('candidate.choices.boardingschool.internship_full') }} - </span>
                    <span v-if="schooling.internship_choice === 'externship_full'">{{ $t('candidate.choices.boardingschool.externship_full') }}  - </span>
                    <span v-if="schooling.internship_choice === 'externship'">{{ $t('candidate.choices.boardingschool.externship') }} - </span>
                    {{ schooling.training_name }} section {{ schooling.training_section_name }}

                    -<i>{{ schooling.campus_name }} - {{ schooling.scholar_year }}</i>
                  </div>
                  <div class="column is-4 has-text-right">
                    <span>
                      {{
                        $t('offers.cart.schooling')
                      }}: <strong><i>{{
                        schoolingChoiceFee(schoolingChoice) + scholarDiscount(schoolingChoice)
                      }} {{ scholarCurrency }}</i></strong>
                      <br>
                    </span>
                    <span v-if="schoolingChoice.discount">
                      <i>{{
                        $t('offers.cart.sibling_discount')
                      }}: - {{ scholarDiscount(schoolingChoice) }} {{ scholarCurrency }}</i>
                      <br>
                    </span>
                    <span v-if="scholarDisbursement()">
                      {{ $t('offers.cart.disbursement') }}: <strong><i>{{
                        scholarDisbursement()
                      }}</i></strong>
                      <b-tooltip
                        :label="$t('candidate.choices.debours_info')"
                        position="is-bottom"
                        animated
                      >
                        <i
                          class="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </b-tooltip>
                    </span>
                  </div>
                </div>


                <div
                  v-if="schoolingChoices && schoolingChoices.length"
                  class="p-t-md"
                >
                  <h5 class="has-text-weight-light has-background-primary p-sm">
                    <strong class="has-text-light"><i>{{ $t('offers.cart.offers') }}</i></strong>
                  </h5>
                  <div class="p-l-sm">
                    <div
                      v-for="choice in schoolingChoices"
                      :key="choice.id"
                      class="p-sm"
                    >
                      <div class="columns is-size-5">
                        <div class="column">
                          <span
                            v-if="choice"
                            class="has-text-weight-light"
                          >{{ choice.offer.name.fr }}</span>
                        </div>
                        <div class="column is-4 has-text-right">
                          <strong><i>{{ choice.price }} {{ order.payment_currency }}</i></strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  filters: {
    moment: function (date) {
      return moment(date).format('LL')
    }
  },
  props: {
    candidate: {type: Object},
    order: {type: Object}
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(
        'auth', [
          'getAccount'
        ]
    ),
    ...mapGetters(
        'orders', [
          'candidateSchooling',
          'candidateSchoolingDetails',
          'candidateSchoolingChoices',
          'checkoutStatus',
          'selectedOrder'
        ]
    ),
    ...mapGetters(
        'organization', [
          'getSchoolBySlug',
          'scholarYears',
          'currentScholarYear',
          'trim2',
          'trim3',
        ]
    ),
    pendingOrder() {
      return this.checkoutStatus === 'pending'
    },
    school() {
      return this.getSchoolBySlug(this.$route.params.school)
    },
    schoolingChoice() {
      return this.candidateSchooling(this.candidate, this.order.order_status, this.order)
    },
    schoolingChoices() {
      return this.candidateSchoolingChoices(this.candidate, this.order.order_status, this.order)
    },
    schooling() {
      return this.candidateSchoolingDetails(this.candidate, this.order.order_status, this.order)
    },
    scholarCurrency() {
      const school = this.getSchoolBySlug(this.$route.params.school)
      return school.fees_currency
    }
  },
  methods: {
    scholarFees() {
      if (this.schooling.school_type === 'boardingschool') {
        return this.getScholarFees(this.schooling)
      }
      if (this.schooling.school_type === 'highschool') {
        return this.schooling.fees.fees
      }
      if (this.schooling.school_type === 'eschool') {
        return this.schooling.fees.fees
      }
    },
    schoolingChoiceFee(schoolingChoice) {
      if (this.schooling.school_type === 'boardingschool') {

        if (schoolingChoice.price) {
          return schoolingChoice.price
        } else {
          return this.getScholarFees(this.schooling)
        }
      }
      if (this.schooling.school_type === 'highschool') {
        return schoolingChoice.price
      }
      if (this.schooling.school_type === 'eschool') {
        return schoolingChoice.price
      }
    },
    getScholarFees(schooling) {
      if (schooling.internship_choice === 'internship') {
        if (schooling.scholar_year !== this.currentScholarYear) {
          return schooling.fees.internship_fees
        } else {
          if (moment(schooling.training_entry_date) < this.trim2) {
            return schooling.fees.internship_fees
          } else if (moment(schooling.training_entry_date) > this.trim2 && moment(schooling.training_entry_date) < this.trim3) {
            return (schooling.fees.internship_trim2_fees ? schooling.fees.internship_trim2_fees : schooling.fees.internship_fees)
          } else if (moment(schooling.training_entry_date) > this.trim3) {
            return (schooling.fees.internship_trim3_fees ? schooling.fees.internship_trim3_fees : schooling.fees.internship_fees)
          }
        }
      }
      if (schooling.internship_choice === 'internship_7') {
        if (schooling.scholar_year !== this.currentScholarYear) {
          return schooling.fees.internship_7_fees
        } else {
          if (moment(schooling.training_entry_date) < this.trim2) {
            return schooling.fees.internship_7_fees
          } else if (moment(schooling.training_entry_date) > this.trim2 && moment(schooling.training_entry_date) < this.trim3) {
            return (schooling.fees.internship_7_trim2_fees ? schooling.fees.internship_7_trim2_fees : schooling.fees.internship_7_fees)
          } else if (moment(schooling.training_entry_date) > this.trim3) {
            return (schooling.fees.internship_7_trim3_fees ? schooling.fees.internship_7_trim3_fees : schooling.fees.internship_7_fees)
          }
        }
      }

      if (schooling.internship_choice === 'internship_full') {
        if (schooling.scholar_year !== this.currentScholarYear) {
          return schooling.fees.internship_full_fees
        } else {
          if (moment(schooling.training_entry_date) < this.trim2) {
            return schooling.fees.internship_full_fees
          } else if (moment(schooling.training_entry_date) > this.trim2 && moment(schooling.training_entry_date) < this.trim3) {
            return (schooling.fees.internship_full_trim2_fees ? schooling.fees.internship_full_trim2_fees : schooling.fees.internship_full_fees)
          } else if (moment(schooling.training_entry_date) > this.trim3) {
            return (schooling.fees.internship_full_trim3_fees ? schooling.fees.internship_full_trim3_fees : schooling.fees.internship_full_fees)
          }
        }
      }
      if (schooling.internship_choice === 'externship_full') {
        if (schooling.scholar_year !== this.currentScholarYear) {
          return schooling.fees.externship_full_fees
        } else {
          if (moment(schooling.training_entry_date) < this.trim2) {
            return schooling.fees.externship_full_fees
          } else if (moment(schooling.training_entry_date) > this.trim2 && moment(schooling.training_entry_date) < this.trim3) {
            return (schooling.fees.internship_full_trim2_fees ? schooling.fees.internship_full_trim2_fees : schooling.fees.externship_full_fees)
          } else if (moment(schooling.training_entry_date) > this.trim3) {
            return (schooling.fees.internship_full_trim3_fees ? schooling.fees.internship_full_trim3_fees : schooling.fees.externship_full_fees)
          }
        }
      }
      if (schooling.internship_choice === 'externship') {
        if (schooling.scholar_year !== this.currentScholarYear) {
          return schooling.fees.externship_fees
        } else {
          if (moment(schooling.training_entry_date) < this.trim2) {
            return schooling.fees.externship_fees
          } else if (moment(schooling.training_entry_date) > this.trim2 && moment(schooling.training_entry_date) < this.trim3) {
            return (schooling.fees.externship_trim2_fees ? schooling.fees.externship_trim2_fees : schooling.fees.externship_fees)
          } else if (moment(schooling.training_entry_date) > this.trim3) {
            return (schooling.fees.externship_trim3_fees ? schooling.fees.externship_trim3_fees : schooling.fees.externship_fees)
          }
        }
      }
    },
    scholarDisbursement() {

      if (this.schooling.internship_choice === 'internship') {
        if (this.schooling.scholar_year !== this.currentScholarYear) {
          return this.school.disbursement + ' ' + this.school.fees_currency
        } else {
          if (moment(this.schooling.training_entry_date) < this.trim2) {
            return this.school.disbursement + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim2 && moment(this.schooling.training_entry_date) < this.trim3) {
            return (this.school.disbursement_trim2 ? this.school.disbursement_trim2 : this.school.disbursement) + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim3) {
            return (this.school.disbursement_trim3 ? this.school.disbursement_trim3 : this.school.disbursement) + ' ' + this.school.fees_currency
          }
        }
      }
      if (this.schooling.internship_choice === 'internship_7') {
        if (this.schooling.scholar_year !== this.currentScholarYear) {
          return this.school.disbursement_7 + ' ' + this.school.fees_currency
        } else {
          if (moment(this.schooling.training_entry_date) < this.trim2) {
            return this.school.disbursement_7 + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim2 && moment(this.schooling.training_entry_date) < this.trim3) {
            return (this.school.disbursement_7_trim2 ? this.school.disbursement_7_trim2 : this.school.disbursement_7) + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim3) {
            return (this.school.disbursement_7_trim3 ? this.school.disbursement_7_trim3 : this.school.disbursement_7) + ' ' + this.school.fees_currency
          }
        }
      }
      if (this.schooling.internship_choice === 'internship_full') {
        if (this.schooling.scholar_year !== this.currentScholarYear) {
          return this.school.disbursement_full + ' ' + this.school.fees_currency
        } else {
          if (moment(this.schooling.training_entry_date) < this.trim2) {
            return this.school.disbursement_full + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim2 && moment(this.schooling.training_entry_date) < this.trim3) {
            return (this.school.disbursement_full_trim2 ? this.school.disbursement_full_trim2 : this.school.disbursement_full) + ' ' + this.school.fees_currency
          } else if (moment(this.schooling.training_entry_date) > this.trim3) {
            return (this.school.disbursement_full_trim3 ? this.school.disbursement_full_trim3 : this.school.disbursement_full) + ' ' + this.school.fees_currency
          }
        }
      }
    },
    scholarDiscount(schoolingChoice) {
      return this.scholarFees() - this.schoolingChoiceFee(schoolingChoice)
    }
  }
}
</script>

<style scoped>

</style>
